<template>
    <div class="double-authentication-status" :class="{ 'is-active': active }">
        <div class="double-authentication-status__icon">
            <CompassIcon v-if="active" icon="lock" />
            <CompassIcon v-else icon="unlock" />
        </div>
        <div class="double-authentication-status__text">
            <h3 class="double-authentication-status__title typographies-heading-h3">
                {{ getTitle }}
            </h3>
            <p class="double-authentication-status__label typographies-paragraph-medium-regular">
                {{ getLabel }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        active: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        getTitle() {
            return this.active
                ? this.$l10n.__('Double authentification activée')
                : this.$l10n.__('Double authentification désactivée');
        },
        getLabel() {
            return this.active
                ? this.$l10n.__('Sécurité de votre compte renforcée.')
                : this.$l10n.__('Renforcez la sécurité de votre compte.');
        },
    },
};
</script>

<style lang="scss" scoped>
.double-authentication-status {
    align-items: center;
    background: var(--colors-common-background-alert-subtle);
    border-radius: var(--spacing-0);
    display: inline-flex;
    margin: var(--spacing-1) 0 40px;
    padding: var(--spacing-1) var(--spacing-3) var(--spacing-1) var(--spacing-1);

    &.is-active {
        background: var(--colors-common-background-success-subtle);
    }

    &__icon {
        align-items: center;
        background: var(--colors-common-background-alert-default);
        border-radius: 4px;
        display: flex;
        height: 56px;
        justify-content: center;
        margin-right: 16px;
        width: 56px;

        &:deep(.compass-icon) {
            width: 36px;
            height: 36px;
            color: var(--colors-common-text-standard-on-color);
        }

        .is-active & {
            background: var(--colors-common-background-success-default);
        }
    }

    &__title {
        margin: 0;
        color: var(--colors-common-text-alert-default);

        .is-active & {
            color: var(--colors-common-text-success-default);
        }
    }

    &__label {
        margin: 0;
    }
}
</style>
